import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Avatar } from "@mui/material";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import Axios from "axios";
import { toast, ToastContainer } from "react-toastify";

const tagStyle = {
  fontFamily: "Nunito", fontSize: 12, fontWeight: 700, color: "#374151",
  background: "#f3f4f6", borderRadius: 20, padding: "4px 12px", whiteSpace: "nowrap",
};

const infoRow = { display: "flex", alignItems: "flex-start", gap: 10, padding: "10px 0", borderBottom: "1px solid #f3f4f6" };
const labelStyle = { fontFamily: "Nunito", fontSize: 12, fontWeight: 700, color: "#9ca3af", minWidth: 120, marginTop: 2 };
const valueStyle = { fontFamily: "Nunito", fontSize: 14, color: "#111827", flex: 1, wordBreak: "break-word" };

const FundCompanyPage = () => {
  const location = useLocation();
  const history = useNavigate();
  const { data } = location.state;
  const [fundcompany] = useState(data);
  const [verified, setVerify] = useState(false);
  const [decline, setDecline] = useState(false);
  const [document, setdocument] = useState();
  const [review, setreview] = useState("");

  const handleVerify = async () => {
    if (!confirm("Are you sure you want to Verify this?")) return;
    await Axios.post("/api/admin/handle-fc/accept", fundcompany)
      .then(() => { toast.success("Successfully Verified"); setVerify(true); history("/admin/verify-fundcompany"); })
      .catch(() => { toast.error("Some Error"); setVerify(false); });
  };

  const handleDecline = async () => {
    if (!confirm("Are you sure you want to Decline this?")) return;
    await Axios.post("/api/admin/handle-fc/decline", fundcompany)
      .then(() => { toast.warning("Successfully Declined"); setDecline(true); setTimeout(() => history("/admin/verify-fundcompany"), 500); })
      .catch(() => { toast.error("Some Error"); setDecline(false); });
  };

  const fetchDocument = async () => {
    await Axios({ method: "GET", url: `/api/admin/documents/${fundcompany.id}` })
      .then((res) => setdocument(res.data.documents))
      .catch(() => {});
  };

  useEffect(() => { fetchDocument(); }, []);

  const sendReview = async () => {
    if (!confirm("Are you sure you want to Send this review?")) return;
    await Axios.post("/api/admin/review", { id: fundcompany.id, reason: review })
      .then(() => toast.success("Successfully Sent Review"))
      .catch(() => toast.error("Some error"));
  };

  const tags = [fundcompany.fundRaisingStatus, fundcompany.targetSize].filter(Boolean);

  return (
    <div style={{ padding: "36px 40px", maxWidth: 960, margin: "0 auto", boxSizing: "border-box" }}>
      {/* Header */}
      <div style={{ background: "#fff", border: "1px solid #e5e7eb", borderRadius: 16, padding: "28px 32px", marginBottom: 24, display: "flex", alignItems: "flex-start", gap: 24 }}>
        <Avatar src={fundcompany.profilePic} variant="rounded" style={{ width: 80, height: 80, border: "1px solid #e5e7eb", flexShrink: 0, borderRadius: 12 }} />
        <div style={{ flex: 1, minWidth: 0 }}>
          <h1 style={{ fontFamily: "Nunito", fontWeight: 800, fontSize: 28, color: "#111827", margin: "0 0 4px" }}>{fundcompany.companyName}</h1>
          <p style={{ fontFamily: "Nunito", fontSize: 14, color: "#6b7280", margin: "0 0 12px" }}>{fundcompany.location?.country}</p>
          {tags.length > 0 && (
            <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginBottom: 12 }}>
              {tags.map((t, i) => <span key={i} style={tagStyle}>{t}</span>)}
            </div>
          )}
          {fundcompany.website && (
            <a href={fundcompany.website} target="_blank" rel="noreferrer"
              style={{ fontFamily: "Nunito", fontSize: 13, color: "#3b82f6", textDecoration: "none" }}>
              {fundcompany.website}
            </a>
          )}
        </div>
      </div>

      {/* Two-column body */}
      <div style={{ display: "grid", gridTemplateColumns: "1fr 340px", gap: 20, alignItems: "start" }}>
        {/* Left: details + Verify/Decline */}
        <div style={{ background: "#fff", border: "1px solid #e5e7eb", borderRadius: 12, padding: "20px 24px" }}>
          <p style={{ fontFamily: "Nunito", fontWeight: 800, fontSize: 13, color: "#374151", margin: "0 0 10px", textTransform: "uppercase", letterSpacing: 1 }}>Fund Details</p>
          <div style={infoRow}><span style={labelStyle}>Target Size</span><span style={valueStyle}>{fundcompany.targetSize || "—"}</span></div>
          <div style={infoRow}><span style={labelStyle}>Raising Status</span><span style={valueStyle}>{fundcompany.fundRaisingStatus || "—"}</span></div>
          <div style={infoRow}><span style={labelStyle}>Email</span><span style={valueStyle}>{fundcompany.contact?.email || "—"}</span></div>
          <div style={infoRow}><span style={labelStyle}>Country</span><span style={valueStyle}>{fundcompany.location?.country || "—"}</span></div>
          {/* Verify / Decline inside fund details card */}
          <div style={{ display: "flex", gap: 10, marginTop: 20, paddingTop: 16, borderTop: "1px solid #f3f4f6" }}>
            <button
              onClick={decline ? undefined : handleDecline}
              style={{ flex: 1, fontFamily: "Nunito", fontSize: 13, fontWeight: 700, background: "#fff", color: decline ? "#9ca3af" : "#dc2626", border: `1px solid ${decline ? "#e5e7eb" : "#dc2626"}`, borderRadius: 8, padding: "10px", cursor: decline ? "default" : "pointer" }}>
              {decline ? "Declined" : "Decline"}
            </button>
            <button
              onClick={verified ? undefined : handleVerify}
              style={{ flex: 1, fontFamily: "Nunito", fontSize: 13, fontWeight: 700, background: verified ? "#e5e7eb" : "#111827", color: verified ? "#9ca3af" : "#fff", border: "none", borderRadius: 8, padding: "10px", cursor: verified ? "default" : "pointer", display: "flex", alignItems: "center", justifyContent: "center", gap: 6 }}>
              <DoneAllIcon style={{ fontSize: 16 }} />
              {verified ? "Verified" : "Verify"}
            </button>
          </div>
        </div>

        {/* Right: documents */}
        <div style={{ background: "#fff", border: "1px solid #e5e7eb", borderRadius: 12, padding: "20px 24px" }}>
          <p style={{ fontFamily: "Nunito", fontWeight: 800, fontSize: 13, color: "#374151", margin: "0 0 12px", textTransform: "uppercase", letterSpacing: 1 }}>Documents</p>
          {document && document.documents && document.documents.length > 0
            ? document.documents.map((v, i) => (
              <a key={i} href={v.location} target="_blank" rel="noreferrer"
                style={{ display: "block", marginBottom: 8, fontFamily: "Nunito", fontSize: 13, fontWeight: 700, color: "#111827", background: "#f3f4f6", borderRadius: 8, padding: "10px 14px", textDecoration: "none", border: "1px solid #e5e7eb" }}>
                Document {i + 1} →
              </a>
            ))
            : <p style={{ fontFamily: "Nunito", fontSize: 13, color: "#9ca3af", margin: 0 }}>No documents found</p>}
        </div>
      </div>

      {/* Send Review — full width below */}
      <div style={{ background: "#fff", border: "1px solid #e5e7eb", borderRadius: 12, padding: "24px 28px", marginTop: 20 }}>
        <p style={{ fontFamily: "Nunito", fontWeight: 800, fontSize: 13, color: "#374151", margin: "0 0 12px", textTransform: "uppercase", letterSpacing: 1 }}>Send Review</p>
        <textarea
          rows={5}
          placeholder="Write feedback for the fund company…"
          onChange={(e) => setreview(e.target.value)}
          value={review}
          style={{ width: "100%", boxSizing: "border-box", fontFamily: "Nunito", fontSize: 14, color: "#111827", border: "1px solid #e5e7eb", borderRadius: 8, padding: "12px 14px", resize: "vertical", outline: "none", lineHeight: 1.6 }}
        />
        <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 12 }}>
          <button onClick={sendReview}
            style={{ fontFamily: "Nunito", fontSize: 13, fontWeight: 700, background: "#111827", color: "#fff", border: "none", borderRadius: 8, padding: "10px 28px", cursor: "pointer" }}>
            Send Review
          </button>
        </div>
      </div>

      <ToastContainer />
    </div>
  );
};

export default FundCompanyPage;
